import { APP_ENV } from '../../shared/config/env';
import * as httpApi from './migrations-api-http';
import * as mockApi from './migrations-api-mock';
import type {
  MigrationActionFormValues,
  MigrationRunRecord,
  ProfileMigrationRecord,
  TenantRunActionFormValues,
} from './types';

const api = APP_ENV.bizApiMode === 'live' ? httpApi : mockApi;

export async function listMigrations(): Promise<ProfileMigrationRecord[]> {
  return api.listMigrations();
}

export async function getMigration(
  id: string,
): Promise<ProfileMigrationRecord | null> {
  return api.getMigration(id);
}

export async function listRuns(migrationId: string): Promise<MigrationRunRecord[]> {
  return api.listRuns(migrationId);
}

export async function applyMigrationAction(
  migrationId: string,
  values: MigrationActionFormValues,
): Promise<ProfileMigrationRecord> {
  return api.applyMigrationAction(migrationId, values);
}

export async function applyTenantRunAction(
  migrationId: string,
  runId: string,
  values: TenantRunActionFormValues,
): Promise<MigrationRunRecord> {
  return api.applyTenantRunAction(migrationId, runId, values);
}

export const migrationKeys = {
  all: ['admin-profile-migrations'] as const,
  list: () => [...migrationKeys.all, 'list'] as const,
  detail: (id: string) => [...migrationKeys.all, 'detail', id] as const,
  runs: (id: string) => [...migrationKeys.all, 'runs', id] as const,
};
